interface newUserTypes {
  username: string;
  email: string;
  password: string;
}

async function createUser(newUser: newUserTypes) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/auth/sign-up`;

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(newUser),
    credentials: "include",
  });
  const result = await response.json();

  return result;
}

export default createUser;
